import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectSprayEventsArray } from 'services/sprayEvents/selectors';
import {
    selectFirstDate,
    selectLastDate
    // @ts-ignore
} from 'components/DatePagination/selectors';
import { AppState } from 'services/types';
import { WorksheetType } from 'services/worksheet/types';
import { selectFertilizerEventsArray } from 'services/fertilizerEvents/selectors';
import {
    WORKSHEET_TYPE_FERTILIZER,
    WORKSHEET_TYPE_WEED_SPRAY
} from 'services/worksheet/constants';
import { Props } from './index';

const selectWorksheetType = (state: AppState, props: Props): WorksheetType =>
    props.worksheetType;

const selectEventExistsInCurrentWeek = createDeepEqualSelector(
    selectSprayEventsArray,
    selectFertilizerEventsArray,
    selectFirstDate,
    selectLastDate,
    selectWorksheetType,
    (
        sprayEventsArray,
        fertilizerEventsArray,
        firstDate: string,
        lastDate: string,
        worksheetType
    ) => {
        let events;

        switch (worksheetType) {
            case WORKSHEET_TYPE_FERTILIZER:
                events = fertilizerEventsArray;
                break;
            case WORKSHEET_TYPE_WEED_SPRAY:
                events = sprayEventsArray.filter(
                    (event) => event.sprayEvent.isWeedSpray
                );
                break;
            default:
                events = sprayEventsArray.filter(
                    (event) => !event.sprayEvent.isWeedSpray
                );
                break;
        }

        return (
            events &&
            !!events.length &&
            events.some(({ startDate }: any) => {
                const date = Date.parse(startDate);

                return (
                    date >= Date.parse(firstDate) &&
                    date <= Date.parse(lastDate)
                );
            })
        );
    }
);

export { selectWorksheetType, selectEventExistsInCurrentWeek };
